export function initStickyHeader() {
    // don't apply sticky logic if there is not sticky-header, so drop-shadow is not removed from main header
    if (document.getElementsByClassName("sticky-header").length === 0) return
    
    let scroll_threshold = 80;
    window.onscroll = function () {
        if (document.body.scrollTop > scroll_threshold || document.documentElement.scrollTop > scroll_threshold) {
            document.body.classList.add("sticky");
        } else {
            document.body.classList.remove("sticky");
        }
    };
}
